

const inkMobileNav = {
  bindings: {
    type: '<'
  },
  template: require('./mobile-nav.template.html'),
  controller: 'MobileNavController'
};

angular
  .module('inkfinder')
  .component('inkMobileNav', inkMobileNav);



// WEBPACK FOOTER //
// ./common/nav/mobile-nav.component.js